import { camelCase } from "change-case";

import { Schematic } from "../../Schematic";
import { ScaffoldingData } from "../ScaffoldingData";
import validatorKt from "../templates/Validator.kt.ejs?raw";
import { addEjsTemplateFile } from "../templating/util/addEjsTemplateFile";

export function scaffoldValidator(schematic: Schematic, data: ScaffoldingData) {
  addEjsTemplateFile(data, `${schematic.name}Validator.kt`, validatorKt, {
    filePackage: data.currentPackage,
    formVar: camelCase(schematic.name!),
    formClass: schematic.name,
  });
}
